export const getMissingInfo = (user, insurancesCount = 0, formatMessage) => {
  const errors = {}
  if (user.insured && insurancesCount === 0) {
    errors.insurance = formatMessage('home.todos.insurance.description')
  }
  return errors
}
